// extracted by mini-css-extract-plugin
module.exports = {"dataviz-loader":"DatavizLoader_dataviz-loader__2VvpR","rotating":"DatavizLoader_rotating__1PKBB","is-active":"DatavizLoader_is-active__M1mlK"};